// extracted by mini-css-extract-plugin
export default {"BackButton":"BackButton_BackButton__1h3TX","BackButton__label":"BackButton_BackButton__label__2bI5j"};